/* MiraSpin™ / Avori storefront script: bundle picker (prices from the store's Kaching deal, a color per trimmer),
   Add to Cart, product gallery, sticky bar, rotating top bar, 180° dial, image tabs and gentle reveals.
   Loaded (deferred) on every page by sections/ms-bar.liquid. */
(function () {
  if (window.msInit) return;
  window.msInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }
  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function route(name, fallback) {
    return ((window.routes && window.routes[name]) || rootUrl() + fallback).replace(/\.js$/, '').replace(/\/$/, '') + '.js';
  }
  function scrollBehavior() { return reduceMotion ? 'auto' : 'smooth'; }

  /* ---------------------------------------------------------------
     Kaching deal → offer prices (cents) by quantity, for this product
     --------------------------------------------------------------- */
  function kachingPrices(productId, unit) {
    var out = {};
    var blocks = document.querySelectorAll('script.kaching-bundles-deal-block-settings');
    for (var i = 0; i < blocks.length; i++) {
      var pid = blocks[i].getAttribute('data-product-id');
      if (pid && String(pid) !== String(productId)) continue;
      var deal;
      try { deal = JSON.parse(blocks[i].textContent); } catch (e) { continue; }
      var bars = (deal && deal.dealBars) || [];
      for (var j = 0; j < bars.length; j++) {
        var b = bars[j];
        if (b.dealBarType && b.dealBarType !== 'quantity-break') continue;
        if (!b.quantity || out[b.quantity]) continue;
        var full = unit * b.quantity, price = null;
        if (b.discountType === 'specific') price = Math.round(b.discountValue * 100);
        else if (b.discountType === 'percentage') price = Math.round(full * (1 - b.discountValue / 100));
        else if (b.discountType === 'fixed' || b.discountType === 'amount') price = Math.round(full - b.discountValue * 100);
        else if (b.discountType === 'default') price = full;
        if (price !== null && price > 0 && price <= full) out[b.quantity] = price;
      }
    }
    return out;
  }

  /* ---------------------------------------------------------------
     Bundle picker
     --------------------------------------------------------------- */
  function Picker(root) {
    this.root = root;
    this.cfg = readJSON(root, '[data-ms-config]') || {};
    this.unit = this.cfg.unit_price || 0;
    this.unitFull = Math.max(this.cfg.unit_full || 0, this.unit);
    this.qty = parseInt(this.cfg.default_offer, 10) || 1;
    var fromUrl = parseInt(new URLSearchParams(window.location.search).get('bundle'), 10);
    if (fromUrl >= 1 && fromUrl <= 3) this.qty = fromUrl;
    var first = this.cfg.default_variant;
    this.colors = [first, first, first];
    var box = root.querySelector('[data-ms-insurance]');
    this.insurance = box ? box.checked : false;
    this.loadPrices();
    this.bind();
    this.render();
  }

  Picker.prototype.loadPrices = function () {
    var live = kachingPrices(this.cfg.product_id, this.unit);
    this.live = Object.keys(live).length > 0;
    this.prices = {};
    for (var n = 1; n <= 3; n++) {
      var fallback = this.cfg.fallback && this.cfg.fallback[n - 1];
      this.prices[n] = live[n] || fallback || this.unit * n;
    }
  };

  Picker.prototype.variant = function (id) {
    var list = this.cfg.variants || [];
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
    return null;
  };

  Picker.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-ms-offer-input')) {
        self.qty = parseInt(t.value, 10) || 1;
      } else if (t.hasAttribute('data-ms-color')) {
        var unit = t.closest('[data-ms-unit]');
        var u = unit ? parseInt(unit.getAttribute('data-ms-unit'), 10) : 1;
        var before = self.colors[0];
        self.colors[u - 1] = parseInt(t.value, 10);
        if (u === 1) {
          // A new first color: carry it to units that still match the old one, and show it in the gallery
          for (var k = 1; k < 3; k++) if (self.colors[k] === before) self.colors[k] = self.colors[0];
          var v = self.variant(self.colors[0]);
          if (v) {
            document.dispatchEvent(new CustomEvent('ms:variant', { detail: v }));
            try {
              var url = new URL(window.location.href);
              url.searchParams.set('variant', v.id);
              window.history.replaceState({}, '', url.toString());
            } catch (err) {}
          }
        }
      } else if (t.hasAttribute('data-ms-insurance')) {
        self.insurance = t.checked;
      } else {
        return;
      }
      self.render();
    });
    this.root.addEventListener('click', function (e) {
      var add = e.target.closest('[data-ms-add]');
      if (add) { e.preventDefault(); self.add(add); }
    });
  };

  Picker.prototype.bestOffer = function () {
    var best = 0, bestEach = Infinity, tie = false;
    for (var n = 1; n <= 3; n++) {
      var each = this.prices[n] / n;
      if (each < bestEach - 0.5) { bestEach = each; best = n; tie = false; }
      else if (Math.abs(each - bestEach) <= 0.5) tie = true;
    }
    return tie || best === 1 ? 0 : best;
  };

  Picker.prototype.selection = function () {
    var counts = {}, order = [];
    for (var i = 0; i < this.qty; i++) {
      var id = this.colors[i];
      if (!counts[id]) { counts[id] = 0; order.push(id); }
      counts[id]++;
    }
    return { counts: counts, order: order };
  };

  Picker.prototype.offerName = function (n) {
    return (this.cfg.names || [])[n - 1] || '';
  };

  Picker.prototype.render = function () {
    var self = this, root = this.root, best = this.bestOffer(), cfg = this.cfg;
    root.querySelectorAll('[data-ms-offer]').forEach(function (card) {
      var n = parseInt(card.getAttribute('data-ms-offer'), 10);
      var price = self.prices[n], full = self.unitFull * n, on = n === self.qty;
      card.classList.toggle('is-selected', on);
      var radio = card.querySelector('[data-ms-offer-input]');
      if (radio) {
        radio.checked = on;
        var units = n + ' ' + (n === 1 ? cfg.unit[0] : cfg.unit[1]);
        var label = [self.offerName(n), units, money(price)];
        if (price < full) label.push('save ' + Math.round((full - price) / full * 100) + '%');
        radio.setAttribute('aria-label', label.join(', '));
      }
      var p = card.querySelector('[data-ms-price]');
      if (p) p.textContent = money(price);
      var f = card.querySelector('[data-ms-full]');
      if (f) { f.textContent = price < full ? money(full) : ''; f.hidden = !(price < full); }
      var each = card.querySelector('[data-ms-each]');
      if (each) { each.textContent = n > 1 ? '· ' + money(Math.round(price / n)) + ' ' + cfg.each_label : ''; each.hidden = n === 1; }
      var save = card.querySelector('[data-ms-save]');
      if (save) {
        var text = price < full ? 'Save ' + Math.round((full - price) / full * 100) + '%' : '';
        save.textContent = text;
        save.hidden = !text;
      }
      var ribbon = card.querySelector('[data-ms-ribbon]');
      if (ribbon) {
        var fixed = (cfg.ribbons || [])[n - 1] || '';
        var rtext = fixed || (n === best ? cfg.best_label : '');
        ribbon.textContent = rtext;
        ribbon.hidden = !rtext;
        ribbon.classList.toggle('is-best', !fixed && n === best);
      }
      var colors = card.querySelector('[data-ms-colors]');
      if (colors) {
        colors.hidden = !on;
        colors.querySelectorAll('[data-ms-unit]').forEach(function (unit) {
          var u = parseInt(unit.getAttribute('data-ms-unit'), 10);
          var want = String(self.colors[u - 1]);
          var name = '';
          unit.querySelectorAll('[data-ms-color]').forEach(function (input) {
            input.checked = input.value === want;
            if (input.checked) name = input.getAttribute('data-ms-color-name');
          });
          var label = unit.querySelector('[data-ms-unit-name]');
          if (label && name) label.textContent = name;
        });
      }
    });

    var sel = this.selection();
    var total = this.prices[this.qty] + (this.insurance && cfg.insurance ? cfg.insurance.price : 0);
    root.querySelectorAll('[data-ms-btn-price]').forEach(function (el) { el.textContent = money(total); });

    // Express checkout can only buy one variant: keep it in step, hide it for mixed colors
    var dc = root.querySelector('[data-ms-dc]');
    if (dc) {
      var mixed = sel.order.length > 1;
      dc.hidden = mixed;
      var note = root.querySelector('[data-ms-dc-mixed]');
      if (note) note.hidden = !mixed;
      var qtyInput = dc.querySelector('[data-ms-dc-qty]');
      var idInput = dc.querySelector('[data-ms-dc-id]');
      if (qtyInput) qtyInput.value = this.qty;
      if (idInput) idInput.value = sel.order[0];
    }

    // Sticky bar mirrors the choice
    var offerText = this.offerName(this.qty);
    document.querySelectorAll('[data-ms-sticky-offer]').forEach(function (el) { el.textContent = offerText; });
    document.querySelectorAll('[data-ms-sticky-price]').forEach(function (el) { el.textContent = money(self.prices[self.qty]); });

    if (cfg.design_mode) this.checkNames();
  };

  // Theme editor only: warn when an offer name like "Buy 1 Get 1 Free" doesn't match the price Kaching charges
  Picker.prototype.checkNames = function () {
    var note = this.root.querySelector('[data-ms-name-note]');
    if (!note) return;
    var msgs = [];
    if (!this.live) msgs.push('Kaching\'s deal isn\'t on this page, so these are fallback prices.');
    for (var n = 2; n <= 3; n++) {
      var m = /buy\s*(\d+)\s*get\s*(\d+)\s*free/i.exec(this.offerName(n));
      if (!m) continue;
      var paid = parseInt(m[1], 10), got = paid + parseInt(m[2], 10);
      if (got !== n) { msgs.push('"' + this.offerName(n) + '" is ' + got + ' trimmers, but this card adds ' + n + '.'); continue; }
      var expect = this.unit * paid;
      if (Math.abs(this.prices[n] - expect) > 1) {
        msgs.push('"' + this.offerName(n) + '" means ' + n + ' for ' + money(expect) + ', but the cart charges ' + money(this.prices[n]) + '.');
      }
    }
    note.textContent = msgs.length ? 'Editor only: ' + msgs.join(' ') + ' Change the price in Kaching or the offer name here.' : '';
    note.hidden = !msgs.length;
  };

  Picker.prototype.add = function (button) {
    var self = this, root = this.root, cfg = this.cfg;
    var error = root.querySelector('[data-ms-error]');
    if (error) error.hidden = true;
    var buttons = [button].concat([].slice.call(document.querySelectorAll('[data-ms-sticky-add]')));
    buttons.forEach(function (b) {
      if (!b) return;
      b.setAttribute('aria-busy', 'true');
      b.disabled = true;
      if (!b.hasAttribute('data-ms-label')) b.setAttribute('data-ms-label', b.innerHTML);
      b.textContent = cfg.busy_label || 'Adding…';
    });
    function done() {
      buttons.forEach(function (b) {
        if (!b) return;
        b.removeAttribute('aria-busy');
        b.disabled = false;
        if (b.hasAttribute('data-ms-label')) { b.innerHTML = b.getAttribute('data-ms-label'); b.removeAttribute('data-ms-label'); }
      });
    }
    self.done = done;
    function fail(err) {
      if (error) {
        error.textContent = (err && err.message) || 'Something went wrong. Please try again.';
        error.hidden = false;
        if (!root.contains(button)) error.scrollIntoView({ behavior: scrollBehavior(), block: 'center' });
      }
      done();
    }

    // The cart ends up holding exactly the selected offer (plus the optional add-on), so pressing Add to Cart again
    // never doubles the order. A first add goes through /cart/add.js (which Shopify's add-to-cart tracking listens
    // to); when MiraSpin is already in the cart, /cart/update.js sets the new quantities instead.
    var sel = this.selection();
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sections = null;
    if (!cfg.skip_cart && cart && typeof cart.getSectionsToRender === 'function') {
      sections = cart.getSectionsToRender().map(function (s) { return s.id; });
    }
    function post(url, body) {
      if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
    }
    fetch(route('cart_url', 'cart'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; })
      .then(function (current) {
        var inCart = {};
        (current.items || []).forEach(function (it) { inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity; });
        var mine = (cfg.variants || []).some(function (v) { return inCart[v.id] > 0; });
        var insId = cfg.insurance && cfg.insurance.id;
        var insWrong = insId && !self.insurance && inCart[insId] > 0;
        if (!mine && !insWrong) {
          var items = sel.order.map(function (id) { return { id: id, quantity: sel.counts[id] }; });
          if (insId && self.insurance && !inCart[insId]) items.push({ id: insId, quantity: 1 });
          return post(route('cart_add_url', 'cart/add'), { items: items });
        }
        var updates = {};
        (cfg.variants || []).forEach(function (v) { updates[v.id] = sel.counts[v.id] || 0; });
        if (insId) updates[insId] = self.insurance ? 1 : 0;
        return post(route('cart_update_url', 'cart/update'), { updates: updates });
      })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
        var json = res.json;
        if (cfg.skip_cart) { window.location.href = rootUrl() + 'checkout'; return; }
        if (cart && typeof cart.renderContents === 'function' && json.sections) {
          var ids = sel.order.map(String);
          var line = (json.items || []).filter(function (it) { return ids.indexOf(String(it.variant_id)) > -1; })[0];
          if (line) { json.id = line.id; json.key = line.key; }
          cart.renderContents(json);
          cart.classList.remove('is-empty');
          document.dispatchEvent(new CustomEvent('ms:added', { detail: { quantity: self.qty } }));
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || rootUrl() + 'cart';
        }
        done();
      })
      .catch(fail);
  };

  function initPickers(scope) {
    (scope || document).querySelectorAll('[data-ms-buy]').forEach(function (root) {
      if (root.getAttribute('data-ms-ready')) return;
      root.setAttribute('data-ms-ready', '1');
      root.msPicker = new Picker(root);
    });
  }
  // Kaching can print its deal settings after this script runs: refresh the prices once it has
  function refreshPrices() {
    document.querySelectorAll('[data-ms-buy]').forEach(function (root) {
      var p = root.msPicker;
      if (!p || p.live) return;
      p.loadPrices(); p.render();
    });
  }

  /* ---------------------------------------------------------------
     Product gallery: swipe/scroll-snap slider with thumbnails
     --------------------------------------------------------------- */
  function initGalleries(scope) {
    (scope || document).querySelectorAll('[data-ms-gallery]').forEach(function (g) {
      if (g.getAttribute('data-ms-ready')) return;
      g.setAttribute('data-ms-ready', '1');
      var track = g.querySelector('[data-ms-track]');
      var slides = [].slice.call(g.querySelectorAll('[data-ms-slide]'));
      var thumbs = [].slice.call(g.querySelectorAll('[data-ms-thumb]'));
      var prev = g.querySelector('[data-ms-prev]'), next = g.querySelector('[data-ms-next]');
      var count = g.querySelector('[data-ms-current]');
      if (!track || !slides.length) return;
      var index = 0;
      function go(i, instant) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : scrollBehavior() });
        mark(i);
      }
      function mark(i) {
        index = i;
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (thumbs[i] && thumbs[i].parentNode) {
          var strip = thumbs[i].parentNode, t = thumbs[i];
          if (t.offsetLeft < strip.scrollLeft || t.offsetLeft + t.offsetWidth > strip.scrollLeft + strip.clientWidth) {
            strip.scrollTo({ left: t.offsetLeft - 20, behavior: scrollBehavior() });
          }
        }
        if (count) count.textContent = i + 1;
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        slides.forEach(function (s, k) {
          if (k !== i) s.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
        });
      }
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== index) mark(i);
        });
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      });
      document.addEventListener('ms:variant', function (e) {
        var id = e.detail && e.detail.media_id;
        if (!id) return;
        for (var k = 0; k < slides.length; k++) {
          if (String(slides[k].getAttribute('data-media-id')) === String(id)) { go(k); break; }
        }
      });
      mark(0);
    });
  }

  /* ---------------------------------------------------------------
     Sticky add to cart: shown once the bundle picker has scrolled away
     --------------------------------------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-ms-sticky]');
    var buy = document.getElementById('ms-buy');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.ms-footer, footer');
    var buyVisible = true, footerVisible = false;
    function render() {
      var on = !buyVisible && !footerVisible && buy.getBoundingClientRect().top < 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.body.classList.toggle('ms-sticky-on', on);
    }
    new IntersectionObserver(function (en) { buyVisible = en[0].isIntersecting; render(); }, { threshold: 0 }).observe(buy);
    if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; render(); }, { threshold: 0 }).observe(footer);
    bar.addEventListener('click', function (e) {
      var add = e.target.closest('[data-ms-sticky-add]');
      if (add && buy.msPicker) { e.preventDefault(); buy.msPicker.add(add); return; }
      if (e.target.closest('[data-ms-sticky-change]')) {
        e.preventDefault();
        var offers = buy.querySelector('.ms-offers') || buy;
        offers.scrollIntoView({ behavior: scrollBehavior(), block: 'center' });
        var sel = buy.querySelector('.ms-offer.is-selected input');
        if (sel) setTimeout(function () { sel.focus({ preventScroll: true }); }, reduceMotion ? 0 : 450);
      }
    });
  }

  // Links to #ms-buy / #bundles scroll to the picker smoothly
  function initBuyLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="#ms-buy"], a[href="#bundles"]');
      if (!a) return;
      var buy = document.getElementById('ms-buy');
      if (!buy) return;
      e.preventDefault();
      buy.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
    });
  }

  /* ---------------------------------------------------------------
     Rotating top bar messages
     --------------------------------------------------------------- */
  function initBar() {
    document.querySelectorAll('[data-ms-rotate]').forEach(function (track) {
      if (track.getAttribute('data-ms-ready')) return;
      track.setAttribute('data-ms-ready', '1');
      var msgs = track.querySelectorAll('.ms-bar__msg');
      if (msgs.length < 2 || reduceMotion) return;
      var i = 0, secs = parseInt(track.getAttribute('data-ms-rotate'), 10) || 5;
      setInterval(function () {
        if (window.matchMedia('(min-width: 990px)').matches && track.classList.contains('ms-bar__track--row')) return;
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, secs * 1000);
    });
  }

  /* ---------------------------------------------------------------
     Image tabs (180° section) and the dial illustration
     --------------------------------------------------------------- */
  function initViews(scope) {
    (scope || document).querySelectorAll('[data-ms-views]').forEach(function (wrap) {
      if (wrap.getAttribute('data-ms-ready')) return;
      wrap.setAttribute('data-ms-ready', '1');
      var tabs = [].slice.call(wrap.querySelectorAll('[role="tab"]'));
      var views = [].slice.call(wrap.querySelectorAll('[data-ms-view]'));
      function show(i, focus) {
        tabs.forEach(function (t, k) {
          var on = k === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        views.forEach(function (v, k) { v.classList.toggle('is-active', k === i); v.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      }
      // Hidden tab photos are lazy: start loading them once the section is close, so switching tabs is instant
      var imgs = wrap.querySelectorAll('[data-ms-view] img');
      if ('IntersectionObserver' in window) {
        var pre = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          imgs.forEach(function (img) { img.loading = 'eager'; });
          pre.disconnect();
        }, { rootMargin: '600px 0px' });
        pre.observe(wrap);
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { show(k); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); show((k + 1) % tabs.length, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); show((k - 1 + tabs.length) % tabs.length, true); }
        });
      });
      show(0);
    });
  }

  function initDials(scope) {
    (scope || document).querySelectorAll('[data-ms-dial]').forEach(function (svg) {
      if (svg.getAttribute('data-ms-ready')) return;
      svg.setAttribute('data-ms-ready', '1');
      var arc = svg.querySelector('[data-ms-dial-arc]');
      var needle = svg.querySelector('[data-ms-dial-needle]');
      var knob = svg.querySelector('[data-ms-dial-knob]');
      if (!arc || !needle || !knob) return;
      var cx = 120, cy = 120, r = 96, len = Math.PI * r;
      arc.style.strokeDasharray = len;
      function set(deg) {
        var a = deg * Math.PI / 180;
        var x = cx - r * Math.cos(a), y = cy - r * Math.sin(a);
        arc.style.strokeDashoffset = len * (1 - deg / 180);
        needle.setAttribute('x2', x.toFixed(2)); needle.setAttribute('y2', y.toFixed(2));
        knob.setAttribute('cx', x.toFixed(2)); knob.setAttribute('cy', y.toFixed(2));
      }
      function sweep() {
        if (reduceMotion) { set(180); return; }
        var start = null, dur = 1800;
        function step(ts) {
          if (!start) start = ts;
          var t = Math.min(1, (ts - start) / dur);
          var e = 1 - Math.pow(1 - t, 3);
          set(180 * e);
          if (t < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      set(reduceMotion ? 180 : 0);
      if (!('IntersectionObserver' in window)) { set(180); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { sweep(); io.disconnect(); }
      }, { threshold: 0.5 });
      io.observe(svg);
      svg.addEventListener('click', sweep);
    });
  }

  /* ---------------------------------------------------------------
     Gentle reveal for below-the-fold blocks
     --------------------------------------------------------------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-ms-reveal]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('is-in');
        io.unobserve(el);
        // Once revealed, hand transitions back to the element's own styles (hover effects)
        setTimeout(function () { el.classList.remove('ms-pre'); }, 1400);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      if (el.getAttribute('data-ms-ready')) return;
      el.setAttribute('data-ms-ready', '1');
      if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('ms-pre'); io.observe(el); }
      else el.classList.add('is-in');
    });
  }

  function init() {
    initPickers();
    initGalleries();
    initSticky();
    initBuyLinks();
    initBar();
    initViews();
    initDials();
    initReveal();
    setTimeout(refreshPrices, 600);
    window.addEventListener('load', refreshPrices);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Back from checkout (page restored from the back/forward cache): reset the buttons
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-ms-buy]').forEach(function (root) { if (root.msPicker && root.msPicker.done) root.msPicker.done(); });
  });

  // Theme editor: re-init sections when they're re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    initPickers(e.target); initGalleries(e.target); initBar(); initViews(e.target); initDials(e.target); initReveal(e.target);
  });
})();
